// extracted by mini-css-extract-plugin
export default {"container":"signup_container__rblwQ","title":"signup_title__cbP-9","item":"signup_item__vhDZV","locLabel":"signup_locLabel__+HhX6","buttons":"signup_buttons__WapGx"};